import { useEffect, useMemo, useState } from 'react';
import {
  DashboardJobsStatus,
  DashboardJobsType,
  useDashboardJobInfo,
  useGetDashboardJobs,
} from '~/domain/DashboardJobs';

interface IUseJobListProps {
  status: DashboardJobsStatus;
  jobType: DashboardJobsType;
}

export const useJobList = ({ status, jobType }: IUseJobListProps) => {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, isFetching, isPending, isLoading, isRefetching } = useGetDashboardJobs({
    limit: 15,
    page: currentPage,
    status,
    jobType,
  });
  const info = useDashboardJobInfo(jobType);

  const totalPages = useMemo(() => {
    let counts = 0;

    switch (status) {
      case DashboardJobsStatus.ACTION_REQUIRED:
        counts = info?.pendingCount || 0;
        break;
      case DashboardJobsStatus.FILLED:
        counts = info?.filledCount || 0;
        break;
      case DashboardJobsStatus.OPEN:
        counts = info?.openCount || 0;
        break;
    }

    return Math.ceil(counts / 15);
  }, [info?.filledCount, info?.openCount, info?.pendingCount, status]);

  useEffect(() => {
    setCurrentPage(1);
  }, [jobType]);

  return {
    data,
    isInitialLoading: isLoading,
    isLoading: isLoading || isPending || isFetching || isRefetching,
    methods: {
      setCurrentPage,
    },
    pagination: {
      currentPage,
      totalPages,
    },
  };
};
